import { createSlice } from "@reduxjs/toolkit";
import { IStudentResourceSlice } from "../../../models/master/studentResource";


const initialStudentResourceState: IStudentResourceSlice = {
  studentResources:undefined,
  studentResource:undefined
};

const studentResourceSlice = createSlice({
  name: "studentResource",
  initialState: initialStudentResourceState,
  reducers: {
    setStudentResources: (state, action: { payload: any }) => {
      state.studentResources = action.payload;
    },
    setStudentResource: (state, action: { payload: any }) => {
      state.studentResource = action.payload;
    },
  },
});

export const { setStudentResources,setStudentResource } =
studentResourceSlice.actions;

const studentResourceReducer = studentResourceSlice.reducer;

export type studentResourceState = ReturnType<typeof studentResourceReducer>;

export default studentResourceReducer;
